import { useEffect, useRef, useState } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { color } from './theme/utils'

const Navigation = styled.nav`
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 0;
  top: 10px;
  z-index: 900;

  a {
    border-bottom: 3px solid ${color('foreground')};
    color: ${color('foreground')};
    font-size: 16px;
    margin-right: 0;
    padding: 8px 16px 8px 0;
  }
`

export const DeveloperNavigation = () => {
  const [developerNavigation, setDeveloperNavigation] = useState<boolean>(false)
  const keysDown = useRef<{ [key: string]: boolean }>({})

  const toggleDeveloperNavigation = (e: KeyboardEvent) => {
    keysDown.current[e.code] = true
    if (keysDown.current['AltLeft'] && keysDown.current['KeyF']) {
      setDeveloperNavigation((prev) => !prev)
    }
  }

  const keyUp = (e: KeyboardEvent) => {
    keysDown.current[e.code] = false
  }

  useEffect(() => {
    // Developer Navigation listener
    window.addEventListener('keydown', toggleDeveloperNavigation)
    window.addEventListener('keyup', keyUp)

    return () => {
      window.removeEventListener('keydown', toggleDeveloperNavigation)
      window.removeEventListener('keyup', keyUp)
    }
  }, [])

  return developerNavigation ? (
    <Navigation>
      Links
      <Link to="/">Home</Link>
    </Navigation>
  ) : null
}
